<template>
  <resource-base
    :loading-display="false"
    :is-management-mode="isManagementMode"
  >
    <template v-slot:display>
      <b-container>
        <display :resource="resource" />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings :publishing="publishing" :resource="resource" />
    </template>
  </resource-base>
</template>
<script>
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
export default {
  name: "ResourceRegistration",
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  props: {
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  },
  methods: {
    showResource() {
      this.show = true;
    },
    handleGoToAppStore() {
      window.open(
        "https://apps.apple.com/us/app/journeybinder/id1446532204",
        "_blank"
      );
    },
    handleGoToPlayStore() {
      window.open(
        "https://apps.apple.com/us/app/journeybinder/id1446532204",
        "_blank"
      );
    }
  },
  mounted() {
    // console.log(`ResourceGamePromo Store is  ${this.$store}`);
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}

.video {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.youtube-player {
  border: 1px solid #1d740c;
  height: 390px;
  width: 480px;
  padding: 0px;
  margin-left: 25px;
  margin-bottom: 25px;
}
</style>
